import { Application } from '@hotwired/stimulus'

// Shared Stimulus application instance for Vite-managed Rails views.
const application = Application.start()

application.debug = false
window.Stimulus = application

export { application }
